<div class="cap-sidebar" [ngClass]="{'cap-sidebar--collapsed': !isExpanded, 'cap-sidebar--dark': darkLayout}">
    <ng-content select="[before]"></ng-content>

    <div class="cap-sidebar__brand">
        <div #brand>
            <ng-content select="[brand]"></ng-content>
        </div>

        <div *ngIf="!brand?.children?.length">
            <div class="brand-wrapper" [routerLink]="homePageUrl">
                <img alt="logo" [src]="logoUrl" />

                <div *ngIf="isExpanded" class="cap-sidebar__title">
                    {{ title }}
                </div>
            </div>
        </div>

    </div>

    <ul class="cap-sidebar__menus">
        <ng-container *ngFor="let menu of menus; let i = index; last as last; first as first">
            <li *ngIf="templates | columnTemplate: 'item' as customTemplate; else defaultMenuItem">
                <ng-container [ngTemplateOutletContext]="{ item: menu, index: i, last: last, first: first }"
                              [ngTemplateOutlet]="customTemplate">
                </ng-container>
            </li>

            <ng-template #defaultMenuItem>
                <li *ngIf="!menu?.hidden"
                    routerLinkActive="active"
                    [attr.data-test]="menu.routerLink"
                    [routerLinkActiveOptions]="routerOptions"
                    [routerLink]="'/' + menu.routerLink"
                    [pTooltip]="menu?.label | observablePipe | async"
                    tooltipStyleClass="cap-sidebar-tooltip"
                    [tooltipDisabled]="tooltipDisabled"
                    [tooltipPosition]="tooltipPosition">
                    <i [className]="menu.icon"></i>

                    <span *ngIf="isExpanded" [innerHTML]="menu.label | observablePipe | async"></span>
                </li>
            </ng-template>
        </ng-container>
    </ul>

    <div *ngIf="expandable" class="cap-sidebar__button" (click)="toggleExpanded()">
        <ng-container *ngIf="isExpanded; else collapsedButton">
            <i [classList]="collapseIcon"></i>
        </ng-container>

        <ng-template #collapsedButton>
            <i [classList]="expandIcon"></i>
        </ng-template>
    </div>

    <ng-content select="[after]"></ng-content>
</div>
